import axios from "axios";

//let urlVocacion = "http://unicahdev.ovocacional.unicah.edu/apivoc/";

const urlVocacion = process.env.REACT_APP_API_BASE_URL


export const fetchData = async (endpoint) => {
  try {
    const response = await axios.get(`${urlVocacion}${endpoint}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from ${endpoint}:`, error);
    return error.response;
  }
};
